import axiosInstance from '../../../../services/api';

const BULK_INITIALIZE_API_ENDPOINT = '/api/treatments/multichoix/bulk-initialize/';

/**
 * Normalize an array of IDs - ensures each ID is separate (splits comma-separated strings)
 * @param {Array} arr - Array that may contain comma-separated strings
 * @returns {Array<string>} - Array of individual IDs
 */
const normalizeIdArray = (arr) => {
  if (!arr || !Array.isArray(arr)) return [];

  return arr.flatMap((item) => {
    if (typeof item === 'string' && item.includes(',')) {
      // Split comma-separated string into individual IDs
      return item.split(',').map((id) => id.trim()).filter(Boolean);
    }
    return item;
  }).filter(Boolean);
};

/**
 * Service for multichoix bulk initialization API
 * Fetches labels for IDs when restoring URL state (cold start)
 */
export const MultichoixBulkInitializeService = {
  /**
   * Bulk fetch labels for multichoix URL state restoration
   * @param {Object} ids - Object containing arrays of IDs to fetch
   * @param {Array<string>} [ids.culture_ids] - Culture UUIDs
   * @param {Array<string>} [ids.cultural_practice_ids] - Cultural practice UUIDs
   * @param {Array<string>} [ids.treatment_type_ids] - Treatment type UUIDs
   * @param {Array<string>} [ids.enemy_ids] - Enemy UUIDs
   * @param {Array<string>} [ids.intervention_period_ids] - Intervention period UUIDs
   * @param {Array<string>} [ids.application_type_ids] - Application type UUIDs
   * @returns {Promise<Object>} Labels for all provided IDs
   */
  async bulkInitialize(ids) {
    try {
      // Normalize all ID arrays to ensure they contain individual UUIDs (not comma-separated strings)
      const { data } = await axiosInstance.post(BULK_INITIALIZE_API_ENDPOINT, {
        culture_ids: normalizeIdArray(ids.culture_ids),
        cultural_practice_ids: normalizeIdArray(ids.cultural_practice_ids),
        treatment_type_ids: normalizeIdArray(ids.treatment_type_ids),
        enemy_ids: normalizeIdArray(ids.enemy_ids),
        intervention_period_ids: normalizeIdArray(ids.intervention_period_ids),
        application_type_ids: normalizeIdArray(ids.application_type_ids),
      });
      return data;
    } catch (error) {
      console.error('[MultichoixBulkInitialize] API error:', error);
      throw error;
    }
  },
};

export default MultichoixBulkInitializeService;
